var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYotiIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_light@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "age-scan->-user-experience",
    transform: "translate(-556.000000, -2723.000000)",
    stroke: "#000000",
    strokeWidth: 2.65714286
  }, /*#__PURE__*/React.createElement("g", {
    id: "page-content",
    transform: "translate(352.000000, 537.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guidance",
    transform: "translate(9.000000, 2016.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guidance-example",
    transform: "translate(159.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_light",
    transform: "translate(37.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2167857,4.5198 L23.2167857,0 M23.2167857,46.4990036 L23.2167857,41.9795357 M4.46134286,23.2157893 L0,23.2157893 M46.5,23.2157893 L42.0386571,23.2157893",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.93298214,9.07215 L5.72979643,5.91114643 M40.7034429,40.5204321 L37.5005893,37.3590964 M9.09274286,37.3594286 L5.97790714,40.4742643 M40.541025,5.91114643 L37.4261893,9.02565",
    id: "Shape",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4460357,23.9109643 C36.4460357,16.7008071 30.6009857,10.855425 23.3904964,10.855425 C16.1800071,10.855425 10.3352893,16.7008071 10.3352893,23.9109643 C10.3352893,31.1211214 16.1803393,36.9661714 23.3904964,36.9661714 C30.6009857,36.9661714 36.4457036,31.1207893 36.4457036,23.9109643 L36.4460357,23.9109643 Z",
    id: "Path"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYotiIconLight);
export default __webpack_public_path__ + "static/media/Yoti_icon_light.805c3c84078f570a07d08e378bb23ee1.svg";
export { ForwardRef as ReactComponent };